import './style.scss';
import Grid from './grid.js';

export default Grid;